import { motion } from "framer-motion";

const RED_BARS = [1, 1, 1, 1, 1, 1, 1];
const OFF = 0.18;

const RedBars = ({ reverse = false }) => {
  const count = RED_BARS.length;

  return (
    <>
      {RED_BARS.map((_, i) => {
        const delay = reverse ? (count - i - 1) * 0.15 : i * 0.15;

        return (
          <motion.div
            key={i}
            className="w-[27px] h-[28px] bg-[#A9160F]"
            animate={{
              opacity: [OFF, 1, OFF],
              filter: ["brightness(0.6)", "brightness(1)", "brightness(0.6)"],
            }}
            transition={{
              duration: 2,
              ease: "easeInOut",
              repeat: Infinity,
              delay, // ترتیب delay بر اساس prop reverse
            }}
          />
        );
      })}
    </>
  );
};

const CyberBoxChallengs = ({children}) => {
  return (
    <div className="w-[calc(100%-136px-136px)]  mx-auto relative h-[85vh]">
      <div className="w-full h-full absolute ">{children}</div>
      <div className="w-full absolute top-0 flex justify-between ">
        <div className="w-[360px] flex gap-3  justify-end -skew-x-[25deg]">
          <RedBars reverse />
        </div>

        <div className="w-[360px] flex gap-3  skew-x-[25deg]">
          <RedBars />
        </div>
      </div>
      <div className="left-[300px] right-[300px] absolute bottom-[18px] flex justify-between ">
        <div className="w-[360px] flex gap-3  justify-end skew-x-[25deg]">
          <RedBars reverse />
        </div>

        <div className="w-[360px] flex gap-3  -skew-x-[25deg]">
          <RedBars />
        </div>
      </div>
      <div className="w-full flex justify-between bottom-0 absolute">
        <div className="w-[360px] flex justify-end">
          <motion.div
            initial={{ width: 0 }}
            animate={{ width: 300 }}
            transition={{ duration: 0.5, ease: "easeInOut", delay: 1 }}
            className="w-[300px] h-[28px]  bg-gradient-to-r from-[#A9160F]/0 to-[#A9160F] skew-x-[25deg]"
          ></motion.div>
        </div>

        <div className="w-[360px] flex ">
          <motion.div
            initial={{ width: 0 }}
            animate={{ width: 300 }}
            transition={{ duration: 0.5, ease: "easeInOut", delay: 1 }}
            className="w-[300px] h-[28px] bg-gradient-to-l from-[#A9160F]/0 to-[#A9160F] -skew-x-[25deg]"
          ></motion.div>
        </div>
      </div>
      <div className="w-full h-full relative">
        <div className="w-[calc(100%-384px-384px)] mx-auto h-full border-t-[3px] border-b-[3px] border-t-[#A9160F] border-b-[#A9160F]"></div>

        <div className="w-[384px] h-[94px] absolute left-0 top-0 ">
          <div className="w-full h-full relative">
            <div className="w-[324px] absolute left-[53px] -top-[1px] h-[45px] flex justify-end ">
              <div className="h-full w-[3px]  bg-[#A9160F] rotate-[26deg]"></div>
            </div>
            <div className="h-[74px] w-[3px] bg-[#A9160F] rotate-[45deg] absolute top-[30px] left-[26px]"></div>
          </div>
          <div className="w-[313px] h-[3px] absolute top-[40px] left-[53px] bg-[#A9160F]"></div>
        </div>

        <div className="w-[384px] h-[94px] absolute right-0 top-0 ">
          <div className="w-[313px] h-[3px] absolute top-[43px] right-[53px] bg-[#A9160F]"></div>
          <div className="w-full h-full relative">
            <div className="w-[324px] absolute right-[52px] -top-[1px] h-[47.5px] flex  ">
              <div className="h-full w-[3px] bg-[#A9160F] -rotate-[26deg]"></div>
            </div>
            <div className="h-[73px] w-[3px] bg-[#A9160F] -rotate-[45deg] absolute top-[33px] right-[26px]"></div>
          </div>
        </div>

        <div className="w-[384px] h-[94px] absolute left-0 bottom-0 ">
          <div className="w-[313px] h-[3px] absolute bottom-[43px] left-[53px] bg-[#A9160F]"></div>
          <div className="w-full h-full relative">
            <div className="w-[324px] absolute left-[53px] -bottom-[1px] h-[47px] flex justify-end ">
              <div className="h-full w-[3px]  bg-[#A9160F] -rotate-[26deg]"></div>
            </div>
            <div className="h-[70.5px] w-[3px] bg-[#A9160F] -rotate-[45deg] absolute bottom-[33px] left-[25px]"></div>
          </div>
        </div>

        <div className="w-[384px] h-[94px] absolute right-0 bottom-0 ">
          <div className="w-[313px] h-[3px] absolute bottom-[43px] right-[53px] bg-[#A9160F]"></div>
          <div className="w-full h-full relative">
            <div className="w-[324px] absolute right-[374px] -bottom-[1px] h-[47px] flex justify-end ">
              <div className="h-full w-[3px]  bg-[#A9160F] rotate-[26deg]"></div>
            </div>
            <div className="h-[70.5px] w-[3px] bg-[#A9160F] rotate-[45deg] absolute bottom-[33px] right-[25px]"></div>
          </div>
        </div>
        <div className="w-full absolute h-[calc(100%-94px-94px)] top-[94px] border-l-[#A9160F] border-r-[#A9160F]  border-l-[3px] border-r-[3px] "></div>
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1.5, ease: "easeInOut" }}
        className="w-[calc(100%-27px-27px)] left-[27px] h-[calc(100%-70px-70px)] top-[70px] absolute  "
      >
        <div className="w-full h-full  relative">
          <div className="w-full border-l-[3px] border-r-[3px] border-l-[#A9160F] border-r-[#A9160F] h-[calc(100%-52px-52px)] absolute top-[52px]"></div>
          <div className="w-[3px] h-[72px] rotate-45 bg-[#A9160F] absolute -top-[9px] left-[26px]"></div>
          <div className="w-[3px] h-[72px] -rotate-45 bg-[#A9160F] absolute -top-[9px] right-[26px]"></div>
          <div className="w-[3px] h-[72px] rotate-45 bg-[#A9160F] absolute -bottom-[9px] right-[26px]"></div>
          <div className="w-[3px] h-[72px] -rotate-45 bg-[#A9160F] absolute -bottom-[9px] left-[26px]"></div>
          <div className="w-[calc(100%-52px-52px)] left-[52px] absolute h-full  border-t-[3px] border-b-[#A9160F] border-t-[#A9160F] border-b-[3px]"></div>
        </div>
      </motion.div>

      <motion.div
        initial={{ scale: 0.8, opacity: 0.3 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{
          duration: 0.5,
          ease: "easeInOut",
        }}
        className="h-[calc(85vh-100px-100px)] w-[calc(100%-60px-60px)]  absolute top-[100px] left-[60px]"
      >
        <div className="w-full h-full relative">
          <motion.div
            initial={{ scaleX: 0.9 }}
            animate={{ scaleX: [0.9, 1, 0.9] }}
            transition={{
              duration: 2.5,
              ease: "easeInOut",
              repeat: Infinity,
              delay: 1.5,
            }}
            className="w-[calc(100%-600px-600px)] absolute left-[600px] h-full border-t-[3px] border-t-[#A9160F] border-b-[3px] border-b-[#A9160F]"
          />
          <div className="w-[100px] absolute left-[30px] h-full border-t-[3px] border-b-[3px] border-t-[#A9160F] border-b-[#A9160F]"></div>
          <div className="w-[100px] absolute right-[30px] h-full border-t-[3px] border-b-[3px] border-t-[#A9160F] border-b-[#A9160F]"></div>
          <div className="w-full h-[100px] absolute  top-[30px] border-l-[3px] border-l-[#A9160F] border-r-[3px] border-r-[#A9160F]"></div>
          <div className="w-full h-[100px] absolute  bottom-[30px] border-l-[3px] border-l-[#A9160F] border-r-[3px] border-r-[#A9160F]"></div>
          <div className="w-full h-full flex items-center">
            <div className="w-full h-[calc(85vh-340px-340px)]  border-l-[3px] border-r-[3px] border-l-[#A9160F] border-r-[#A9160F]"></div>
          </div>
          <div className="w-[3px] h-[42px] bg-[#A9160F] rotate-45 absolute left-[14.5px] -top-[5px]" />
          <div className="w-[3px] h-[42px] bg-[#A9160F] -rotate-45 absolute right-[14.5px] -top-[5px]" />
          <div className="w-[3px] h-[42px] bg-[#A9160F] rotate-45 absolute right-[14.5px] -bottom-[5px]" />
          <div className="w-[3px] h-[42px] bg-[#A9160F] -rotate-45 absolute left-[14.5px] -bottom-[5px]" />
        </div>
      </motion.div>
    </div>
  );
};

export default CyberBoxChallengs;
